export default __webpack_public_path__ + "212caf7e457225d82a26c26ab7d4cc69.png";